import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Wizard/wizard';
import { css } from '@patternfly/react-styles';
export var WizardBody = function WizardBody(_ref) {
  var children = _ref.children,
      _ref$hasNoBodyPadding = _ref.hasNoBodyPadding,
      hasNoBodyPadding = _ref$hasNoBodyPadding === void 0 ? false : _ref$hasNoBodyPadding;
  return React.createElement("main", {
    className: css(styles.wizardMain)
  }, React.createElement("div", {
    className: css(styles.wizardMainBody, hasNoBodyPadding && styles.modifiers.noPadding)
  }, children));
};